module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-5-bf31e3969a08498389a2bbbb8111b67e.jpg";